// Fliken Versioner: alla versioner av katalogen, nyast först (ADR 0022).
import { useKatalogKontext } from './Katalog.js';

const STATUS = { draft: 'Utkast', published: 'Publicerad', archived: 'Arkiverad' } as const;

const datum = (iso: string) =>
  new Intl.DateTimeFormat('sv-SE', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Stockholm',
  }).format(new Date(iso));

export function Versioner() {
  const { data } = useKatalogKontext();
  return (
    <div className="kort tabellkort">
      <table className="tabell dolj-pa-mobil">
        <caption className="visuellt-dold">Versionerna av katalogen</caption>
        <thead>
          <tr>
            <th scope="col">Version</th>
            <th scope="col">Status</th>
            <th scope="col">Senast ändrad</th>
            <th scope="col">Publicerad</th>
          </tr>
        </thead>
        <tbody>
          {data.lista.map((m) => (
            <tr key={m.id}>
              <td className="mono">{m.version}</td>
              <td>{STATUS[m.status]}</td>
              <td>{datum(m.updatedAt)}</td>
              <td>{m.publishedAt ? datum(m.publishedAt) : '–'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="hjalp tabellfot">
        Offerterna räknas alltid på den publicerade versionen. Varje offert sparar vilken version
        den räknades på.
      </p>
    </div>
  );
}
